import { render, staticRenderFns } from "./BranchUsersModal.vue?vue&type=template&id=1a224bf4&scoped=true&"
import script from "./BranchUsersModal.vue?vue&type=script&lang=js&"
export * from "./BranchUsersModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a224bf4",
  null
  
)

export default component.exports